"use client";
import React, { useEffect, useState } from "react";

import AppLogo from "@/assets/icons/app-logo";
import { useStore } from "@/store/store";

function WrapperLoader({ children }: { children: React.ReactNode }) {
  const { isLoading } = useStore();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (isLoading) {
      setShowLoader(true);
    }
 else {
      const timeout = setTimeout(() => setShowLoader(false), 50);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (showLoader) {
    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center flex-col gap-y-2 bg-background">
        <AppLogo />
        <div className="absolute bottom-6 text-center text-muted-foreground">
          <p>From</p>
          <p>Razu Islam</p>
        </div>
      </div>
    );
  }

  return children;
}

export default WrapperLoader;
